var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:['svg-icon', _vm.size && `icon-${_vm.size}`],style:({ pointerEvents: _vm.pointerEvents, color: 'inherit' }),attrs:{"aria-hidden":"true","focusable":"false"}},[_c('use',{attrs:{"href":_vm.href,"xlink:href":_vm.href,"fill":"currentColor","stroke":"currentColor","stroke-width":"1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }